import React from 'react';
import { TextField } from '@material-ui/core';

const MuiTextField = ({ input, label, inputProps, meta: { touched, error, invalid }, ...custom }) => {
  return (
    <TextField
      {...custom}
      onChange={(e) => input.onChange(e)}
      type={'text'}
      helperText={error}
      fullWidth
      label={label}
      InputLabelProps={{
        disableAnimation: true
      }}
      inputProps={{ ...inputProps }}
      error={invalid}
      name={input.name}
      value={input.value}
    />
  );
};

export default MuiTextField;
